import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

axios.defaults.baseURL = "https://superhero-app-0he6.onrender.com";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchHeroes = createAsyncThunk(
  "heroes/fetchAll",
  async (page, thunkAPI) => {
    try {
      await delay(600);
      const response = await axios.get(`/heroes?page=${page}&perPage=5`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const fetchHeroById = createAsyncThunk(
  "heroes/fetchById",
  async (id, thunkAPI) => {
    try {
      await delay(600);
      const response = await axios.get(`/heroes/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const addHero = createAsyncThunk(
  "heroes/addHero",
  async (formData, thunkAPI) => {
    try {
      const response = await axios.post("/heroes", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const updateHero = createAsyncThunk(
  "heroes/updateHero",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(`/heroes/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data; // Повертаємо оновленого героя
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const deleteHero = createAsyncThunk(
  "heroes/deleteHero",
  async (id, thunkAPI) => {
    try {
      await axios.delete(`/heroes/${id}`);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);
